import type {RouteParams} from 'types/routes'
import {MYPAGE_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/mypage/procedures/parentalLeave/index'
import {ParentalLeaveFlow} from 'pages/withAuth/mypage/procedures/parentalLeave/flow'

export const ParentalLeaveRoutes: RouteParams[] = [
  {
    key: '/mypage/parental_leave',
    path: MYPAGE_PATHS.PROCEDURES.PARENTAL_LEAVE.INDEX,
    component: Index,
    exact: true,
  },
  {
    key: '/mypage/parental_leave/flow/:id',
    path: MYPAGE_PATHS.PROCEDURES.PARENTAL_LEAVE.FLOW,
    component: ParentalLeaveFlow,
    exact: true,
  },
]
